import React, { ChangeEvent, FC } from 'react'
import { useTranslation } from 'react-i18next'
import { AutomatContainerTypes, AutomatModelContainer } from '../../../types'
import { TextField } from '../../simples/TextField'
import { Selector } from '../../simples/Selector'
import { ReactComponent as DeleteIcon } from '../../../assets/icons/delete.svg'
import styles from './ModelEditor.module.scss'

const volumeInputClasses = {
    input: styles.bunkerItemVolumeInput,
}

type Props = {
    container: AutomatModelContainer
    onChange: (container: AutomatModelContainer) => void
    onDelete: () => void
}

export const BunkerItem: FC<Props> = ({ container, onChange, onDelete }) => {
    const { t } = useTranslation()

    const typeOptions = [
        {
            value: AutomatContainerTypes.Powder,
            label: t('176_ModelEditor_powder'),
        },
        {
            value: AutomatContainerTypes.Syrup,
            label: t('178_ModelEditor_syrup'),
        },
    ]

    const handleVolumeChange = (event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value.replace(/\D/, '')

        onChange({
            ...container,
            volume: +value,
        })
    }

    const handleTypeChange = (type: AutomatContainerTypes) => {
        onChange({
            ...container,
            type,
        })
    }

    return (
        <div className={styles.bunkerItem}>
            <div className={styles.bunkerItemNumber}>
                Бункер {container.number}
            </div>

            <div className={styles.bunkerItemVolumeWrap}>
                <TextField
                    value={container.volume}
                    onChange={handleVolumeChange}
                    classes={volumeInputClasses}
                />
                <div className={styles.bunkerItemVolumeUnit}>
                    {container.type === AutomatContainerTypes.Syrup
                        ? t('179_ModelEditor_ml')
                        : t('180_ModelEditor_g')}
                </div>
            </div>

            <div className={styles.bunkerItemTypeWrap}>
                <Selector
                    options={typeOptions}
                    label={t('181_ModelEditor_type')}
                    value={container.type}
                    onChange={handleTypeChange}
                />
            </div>

            <button className={styles.bunkerItemDelete} onClick={onDelete}>
                <DeleteIcon />
            </button>
        </div>
    )
}
